class HeroAction extends HTMLElement {
  constructor() {
    super();
    this.actionButtons = null;
    this.containers = null;
    
    // Bind methods
    this.handleClick = this.handleClick.bind(this);
    this.handleCouponClick = this.handleCouponClick.bind(this);
  }

  connectedCallback() {
    // Find all action buttons within this custom element
    this.actionButtons = this.querySelectorAll('.hero-action');
    this.containers = this.querySelectorAll('.container-hero-action');
    
    // Set up event listeners for each action button
    this.actionButtons.forEach(button => {
      button.addEventListener('click', this.handleClick);
    });
    
    // Set up coupon copy functionality for all coupon codes within this element
    const couponCodes = this.querySelectorAll('.couponcode');
    couponCodes.forEach(couponCode => {
      couponCode.addEventListener('click', this.handleCouponClick);
    });
  }

  disconnectedCallback() {
    // Remove all event listeners
    this.actionButtons?.forEach(button => {
      button.removeEventListener('click', this.handleClick);
    });
    
    const couponCodes = this.querySelectorAll('.couponcode');
    couponCodes.forEach(couponCode => {
      couponCode.removeEventListener('click', this.handleCouponClick);
    });
  }

  handleClick(event) {
    event.preventDefault();
    
    const actionButton = event.currentTarget;
    const container = actionButton.closest('.container-hero-action');
    const toggleElement = actionButton.querySelector('.plusminus');
    
    if (!actionButton || !container) return;
    
    const isOpen = actionButton.classList.contains('open');
    
    if (isOpen) {
      this.close(actionButton, container, toggleElement);
    } else {
      // Close all other hero actions
      this.closeAllActions();
      this.open(actionButton, container, toggleElement);
    }
  }

  open(actionButton, container, toggleElement) {
    if (!actionButton || !container) return;
    
    actionButton.classList.add('open');
    container.classList.add('visibile');
    if (toggleElement) {
      toggleElement.classList.add('active');
    }
    
    setTimeout(() => {
      container.classList.add('show');
    }, 500);
  }

  close(actionButton, container, toggleElement) {
    if (!actionButton || !container) return;
    
    actionButton.classList.remove('open');
    container.classList.remove('show');
    container.classList.remove('visibile');
    if (toggleElement) {
      toggleElement.classList.remove('active');
    }
  }

  closeAllActions() {
    // Close all hero actions on the page
    document.querySelectorAll('.container-hero-action').forEach(container => {
      container.classList.remove('visibile');
      container.classList.remove('show');
    });
    
    document.querySelectorAll('.hero-action').forEach(button => {
      button.classList.remove('open');
    });
    
    document.querySelectorAll('.plusminus').forEach(toggle => {
      toggle.classList.remove('active');
    });
  }

  async handleCouponClick(event) {
    const couponCode = event.currentTarget;
    // Try to get coupon from attribute first, then from text content
    let couponValue = couponCode.getAttribute('coupon');
    
    if (!couponValue) {
      couponValue = couponCode.querySelector('.promo-code-value')?.textContent;
    }
    
    if (!couponValue) return;
    
    try {
      await navigator.clipboard.writeText(couponValue.trim());
      // Optional: Show feedback to user
    } catch (err) {
      // Fallback for older browsers
      const tempInput = document.createElement('input');
      document.body.appendChild(tempInput);
      tempInput.value = couponValue.trim();
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    }
  }
}

customElements.define('hero-action', HeroAction);

